import { Button, NotFoundIllustration } from '@platform/ui';
import { Link } from '@tanstack/react-router';
import { House } from 'lucide-react';

import { BrandLogo } from './brand';
import { useDocumentTitle } from './page';

/** 404: la dirección no lleva a ninguna pantalla (se muestra fuera del menú, con la marca). */
export function NotFoundPage() {
  useDocumentTitle('Página no encontrada');
  return (
    <div className="flex min-h-dvh flex-col bg-background px-4 py-6 sm:px-8">
      <Link to="/overview" className="self-start rounded-md">
        <BrandLogo tone="ink" className="h-9 dark:hidden" />
        <BrandLogo tone="light" className="hidden h-9 dark:block" />
      </Link>
      <main className="mx-auto flex max-w-lg flex-1 flex-col items-center justify-center gap-5 pb-16 text-center">
        <NotFoundIllustration className="h-32" />
        <div className="flex flex-col gap-2">
          <h1 className="text-2xl font-semibold tracking-tight">No encontramos esta página</h1>
          <p className="text-sm text-muted-foreground">
            Puede que la dirección esté mal escrita o que la página ya no exista. Desde el inicio
            llegas a todo lo demás.
          </p>
        </div>
        <Button asChild>
          <Link to="/overview">
            <House /> Ir al inicio
          </Link>
        </Button>
      </main>
    </div>
  );
}
